import { Icon } from "../../../core/components/ui/icon";

/** Numéro tel qu'affiché : « 418 555-0171 » plutôt que « +14185550171 ». */
export function prettyPhone(raw: string): string {
  const digits = raw.replace(/\D/g, "");
  const local = digits.length === 11 && digits.startsWith("1") ? digits.slice(1) : digits;
  if (local.length === 10) return `${local.slice(0, 3)} ${local.slice(3, 6)}-${local.slice(6)}`;
  return raw;
}

/** Rappeler ou texter l'appelant : deux liens natifs, la tablette fait le reste. */
export function PhoneLinks({ number, size = "md" }: { number: string; size?: "md" | "sm" }) {
  const digits = number.replace(/[^\d+]/g, "");
  return (
    <span
      className={`phone-links${size === "sm" ? " phone-links--sm" : ""}`}
      role="group"
      aria-label="Rappeler"
    >
      <a
        className="phone-links__btn"
        href={`tel:${digits}`}
        aria-label="Appeler"
        title="Appeler"
        onClick={(e) => e.stopPropagation()}
      >
        <Icon name="phone" size={size === "sm" ? 16 : 18} />
        <span className="phone-links__label">Rappeler</span>
      </a>
      <a
        className="phone-links__btn"
        href={`sms:${digits}`}
        aria-label="Texto"
        title="Texto"
        onClick={(e) => e.stopPropagation()}
      >
        <Icon name="sms" size={size === "sm" ? 16 : 18} />
        <span className="phone-links__label">Texto</span>
      </a>
    </span>
  );
}
